import { render } from "./legoCarouselHorse.vue?vue&type=template&id=252d27f5"
import script from "./legoCarouselHorse.vue?vue&type=script&lang=js"
export * from "./legoCarouselHorse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoCarousel/legoCarouselHorse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "252d27f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('252d27f5', __exports__)) {
    api.reload('252d27f5', __exports__)
  }
  
  module.hot.accept("./legoCarouselHorse.vue?vue&type=template&id=252d27f5", () => {
    api.rerender('252d27f5', render)
  })

}


export default __exports__